import PropTypes from 'prop-types'
import React from 'react'

export const AddButton = ({onClick}) => (
  <a className='dodaj-model-btn' href='javascript:void (0)' onClick={onClick}>
    <span className='add-model'>[+]</span> Dodaj još modela
  </a>
)

AddButton.propTypes = {
  onClick: PropTypes.func
}
